import React from 'react';
import PropTypes from 'prop-types';
import ExpandableListItemA from 'components/ExpandableListItem/ExpandableListItemA';
import ExpandableListItemB from 'components/ExpandableListItem/ExpandableListItemB';
import ExpandableListItemC from 'components/ExpandableListItem/ExpandableListItemC';
import ExpandableListItemD from 'components/ExpandableListItem/ExpandableListItemD';

class ExpandableListItemContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showBody: false,
    };

    this.onClick = this.onClick.bind(this);
  }

  onClick(e) {
    e.preventDefault();
    const { showBody } = this.state;
    this.setState({ showBody: !showBody });
  }

  render() {
    const { type, ...rest } = this.props;
    const { showBody } = this.state;

    const ComponentTypes = {
      ExpandableListItemA,
      ExpandableListItemB,
      ExpandableListItemC,
      ExpandableListItemD,
    };

    const Component = ComponentTypes[type];

    return (
      Component && <Component {...rest} showBody={showBody} onClick={this.onClick} />
    );
  }
}

ExpandableListItemContainer.propTypes = {
  type: PropTypes.string.isRequired,
};

export default ExpandableListItemContainer;
